module.exports = __webpack_public_path__ + "static/default-img-d8dbc7b22c1c378f41dae5fc6a93b75c.jpg";